/** Display only complete research prose; keep source titles, names and URLs verbatim. */
export function researchProse(value: unknown): string | undefined {
  if (typeof value !== "string" || !value.trim()) return undefined;
  const text = value.trim();
  // Sentence boundaries require whitespace/end, so £191.20 is never split at its decimal.
  const parts = text.split(/(?<=[.!?])\s+/).map((part) => part.trim()).filter(Boolean);
  const tail = parts[parts.length - 1];
  // Legacy structured responses were capped at 500 characters, sometimes mid-sentence.
  if (tail && (text.length === 500 || text.length === 1200) && !/[.!?]["’”)]?$/.test(tail)) parts.pop();
  return parts.filter((part) => !/[£$€]\s*(?:[^\d\s.,+-]|[\d.,]+\s*[/≈]\s*[£$€≈])/.test(part)).join(" ").trim() || undefined;
}
